<template>
    <div class="pagination-container">
        <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="paginationOptions.Page" :page-sizes="pageSizes" :page-size="paginationOptions.PageSize" :layout="layout" :total="paginationOptions.total"></el-pagination>
    </div>
</template>

<script>
export default {
    name: 'Pagination',
    props: {
        paginationOptions: {
            type: Object,
            required: true,
            default: () => ({
                Page: 1,
                total: 0,
                PageSize: 40
            })
        }
    },
    data() {
        return {
            pageSizes: [10, 20, 40, 100],
            layout: 'total, sizes, prev, pager, next'
        };
    },
    methods: {
        handleSizeChange(newSize) {
            this.$emit('size-change', newSize);
        },
        handleCurrentChange(newPage) {
            this.$emit('current-change', newPage);
        }
    }
};
</script>
<style scoped>
.pagination-container {
    /* position: fixed; 
  bottom: 20px; 
  left: 0;
  right: 0; */
    display: flex;
    justify-content: center;
    /* z-index: 1000; */
}
</style>
